/**
 * Allowlist of course slugs whose course page (and child lesson pages) can be
 * reached by anonymous Supabase users without the WordPress login redirect.
 *
 * Adding a slug here:
 *  - skips useWordPressLoginRedirect for /courses/<slug> and /courses/<slug>/*
 *  - triggers an automatic supabase.auth.signInAnonymously() on first visit
 *
 * The lesson page itself still gates the actual content via the get-lesson-new
 * edge function, which returns 403 for anonymous users and the client shows the
 * AccessDenied "Upgrade your membership" screen.
 */
export const ANON_ALLOWED_COURSE_SLUGS: ReadonlySet<string> = new Set([
  'mentor-session-replays',
]);

export function isAnonAllowedPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  const match = pathname.match(/^\/courses\/([^/?#]+)/);
  if (!match) return false;
  return ANON_ALLOWED_COURSE_SLUGS.has(match[1]);
}
